<template>
    <BreadCrumb PageTitle="Modifier un menu" />
    <EditMenu/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue"
    import EditMenu from "@/components/Menus/EditMenu.vue";
  
    export default defineComponent({
      name: "EditMenuPage",
      components: {
        BreadCrumb,
        EditMenu,
      },
    });
  </script>